import Request from "./constants/Request.api"
import Response from "./constants/Response.api"
import Api from "./Api"

const service_id = 17003

class Application extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  createApplication = () => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "client/application/" + service_id,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  getAllApplications = app => {
    const request = new Request({
      data: {
        url: "clients/applications/" + this.user.id,
        //token: "Bearer " + user.token,
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getApplicationsPagination = page => {
    const request = new Request({
      data: {
        url: "clients/applications/" + this.user.id + "?page=" + page,
        //token: "Bearer " + user.token,
      },
    })

    const response = this.getRequest(request)
    return response
  }

  getPlasticTypes = () => {
    const request = new Request({
      data: {
        url: "plastic-types",
      },
    })

    const response = this.getRequest(request)
    return response
  }

  saveApplication = appForm => {
    const request = new Request({
      data: {
        ...appForm,
        client_id: this.user.id,
        service_id: service_id,
        is_submitted: true,
        url: "applications/requests/environmental-audit",
        token: "Bearer " + this.user.token,
      },
    })

    // console.log("app details", request)
    return this.postRequest(request)
  }

  getStatistics = () => {
    const request = new Request({
      data: {
        url: "client/statistics/" + this.user.id,
        //token: "Bearer " + user.token,
      },
    })

    return this.getRequest(request)
  }

  uploadFile = fileDetails => {
    const formData = new FormData()
    formData.append("file", fileDetails.file)
    formData.append("application_id", fileDetails.application_id)
    formData.append("description", fileDetails.description)

    const request = new Request({
      data: {
        formData: formData,
        url: "applications/upload/file",
        token: "Bearer " + this.user.token,
      },
    })
    return this.uploadRequest(request)
  }

  bulkFileUpload = files => {
    var uploadStatus = new Promise((resolve, reject) => {
      files.forEach(file => {
        this.uploadFile(file).then(response => {
          console.log("response from server upload")
          console.log(response)
        })
      })
    })

    uploadStatus.then(() => {
      return new Response({
        code: 200,
        message: "upload success",
        status: true,
      })
    })
  }

  getApplicationDetails = id => {
    //console.log(this.user)
    const request = new Request({
      data: {
        url: "application/" + id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getServiceAttachments = () => {
    const request = new Request({
      data: {
        url: "service/attachments/" + service_id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  downloadAttachment = file => {
    const request = new Request({
      data: {
        url: "service/download-attachment?file=" + file,
        //file: file,
        token: "Bearer " + this.user.token,
      },
    })

    return this.downloadRequest(request)
  }

  downloadAttachment = file => {
    const request = new Request({
      data: {
        url: "service/download-attachment?file=" + file,
        token: "Bearer " + this.user.token,
      },
    })

    return this.downloadRequest(request)
  }

  confirmApprovalConditions = (id, status) => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "application/applicant-confirmation",
        application_id: id,
        applicant_confirmed: status,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  rejectApprovalConditions = (id, status, rejectionReason) => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "application/applicant-confirmation",
        application_id: id,
        applicant_confirmed: status,
        applicant_reject_comment: rejectionReason,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  submitProjectLocations = (locations) => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "environmental-request/locations",
        locations: locations,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  getProjectLocations = (appId) => {
    const request = new Request({
      data: {
        url: "environmental-request/locations/" + appId,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getSectorOfActivities = () => {
    const request = new Request({
      data: {
        url: "sector-of-activity",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  // March 2025
  getTORApplications = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/tor-applications/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getReportsUnderReview = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/reports-under-review-applications/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getPendingReportSubmissions = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/pending-reports-applications/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getWaitingCertificates = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/waiting-certificate-applications/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getApprovedApplications = () => {
    const request = new Request({
      data: {
        url: "environmental-audit/approved-applications/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getStatistics = () => {
    // client-dashboard
    const request = new Request({
      data: {
        url: "environmental-audit/client-dashboard/" + this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
}

export default Application
